import {useEffect, useState} from "react";
import {fetchAuthorizedFile, getFileUrl} from "../request/connect";

export const useAuthorizedFileUrl = (file?: string | null) => {
    const [url, setUrl] = useState("");

    useEffect(() => {
        let isActive = true;
        let objectUrl = "";

        if (!file) {
            setUrl("");
            return;
        }

        const normalizedUrl = getFileUrl(file);
        if (normalizedUrl.startsWith("blob:") || normalizedUrl.startsWith("data:")) {
            setUrl(normalizedUrl);
            return;
        }

        setUrl("");
        fetchAuthorizedFile(normalizedUrl).then(blob => {
            if (!isActive) return;
            objectUrl = URL.createObjectURL(blob);
            setUrl(objectUrl);
        }).catch(() => {
            if (isActive) setUrl("");
        });

        return () => {
            isActive = false;
            if (objectUrl) URL.revokeObjectURL(objectUrl);
        };
    }, [file]);

    return url;
}
